<template>
  <div class="sidemenu-body">
    <VuePerfectScrollbar v-once>
      <ul class="sidemenu-nav metisMenu h-100" id="sidemenu-nav" data-simplebar>
        <template v-for="(item, index) in menu">
          <li class="nav-item" v-if="item.child" :key="index">
            <div v-if="checkChild(item)">
              <a class="nav-link collapsed-nav-link" v-b-toggle="'accordion-' + item.accId">
                <i :class="item.icon"></i>
                <span class="menu-title">{{ item.title }}</span>
              </a>
              <b-collapse
                :id="'accordion-' + item.accId"
                accordion="my-accordion"
                role="tabpanel"
                class="sidemenu-nav-second-level"
              >
                <div v-for="(subItem, subIndex) in item.child" :key="subIndex">
                  <div v-if="checkPermission(subItem.permission)">
                    <li class="nav-item" @click="changeRoute(subItem)">
                      <router-link :to="subItem.href" class="nav-link">
                        <span class="menu-title">{{ subItem.title }}</span>
                      </router-link>
                    </li>
                  </div>
                </div>
              </b-collapse>
            </div>
          </li>
          <router-link
            v-else
            custom
            :key="item.href"
            :to="item.href"
            v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <div v-if="checkPermission(item.permission)">
              <li
                class="nav-item"
                :class="[
                  isActive && 'router-link-active mm-active',
                  isExactActive && 'router-link-exact-active',
                ]"
                @click="changeMenu(item)"
              >
                <a :href="href" @click="navigate" class="nav-link">
                  <i :class="item.icon"></i>
                  <span class="menu-title">{{ item.title }}</span>
                </a>
              </li>
            </div>
          </router-link>
        </template>
      </ul>
    </VuePerfectScrollbar>
  </div>
</template>

<script>
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'
  import { menu } from '@/config/menu_v2.js'
  import { mapGetters } from 'vuex'

  export default {
    components: {
      VuePerfectScrollbar,
    },

    props: {
      isOpen: Boolean,
      isOpenMobile: Boolean,
    },

    data() {
      return {
        sidebarActive: false,
        collapsed: true,
        windowWidth: 0,
        menu: menu,
      }
    },

    computed: {
      ...mapGetters({
        getRouterSavingSearch: 'search/getRouter',
        dataPermission: 'role/dataPermission',
      }),
    },

    methods: {
      checkPermission(per) {
        if (per !== '') {
          if (this.dataPermission) {
            let check = false
            if (typeof per === 'object') {
              check = !!per?.find(s => this.dataPermission.includes(s))
            } else check = this.dataPermission.includes(per)
            return check
          }
        } else {
          return true
        }
      },
      checkChild(child) {
        if (this.dataPermission && child.listPermission) {
          const childPer = []
          child.listPermission.map(item => {
            const check = this.dataPermission.includes(item)
            if (check) childPer.push(item)
          })
          if (childPer.length === 0) {
            return false
          } else {
            return true
          }
        } else {
          return true
        }
      },
      changeRoute(item) {
        if (item !== '/attendance') {
          this.$store.commit('search/CLEAR_DATA')
        }
        if (this.getRouterSavingSearch !== null && item !== this.getRouterSavingSearch) {
          this.$store.commit('search/CLEAR_DATA_OTHER')
        }
      },
      changeMenu(item) {
        if (item.accId !== 2) {
          this.$store.commit('search/CLEAR_DATA')
        }
        if (
          this.getRouterSavingSearch !== null &&
          item.href &&
          item.href !== this.getRouterSavingSearch
        ) {
          this.$store.commit('search/CLEAR_DATA_OTHER')
        }
      },
    },
  }
</script>

<style scoped>
  .router-link-exact-active {
    color: #0b62ab !important;
  }
</style>
